import { SET_PCR_HOME_VALIDATED_ADDRESS } from 'src/store/actions/types';
import appService from 'src/pl.service';
import { statuses } from 'src/constants/statuses';

/**
 * commits the id to the store using the SET_PCR_HOME_VALIDATED_ADDRESS action type
 */
export const setPcrHomeValidatedAddress = async ({ commit, state }) => {
  try {
    var validatedAddress = null;
    if (state.applicant.epcrJsonData && state.applicant.epcrJsonData.haddr) {
      validatedAddress = await appService.getValidatedAddress(
        state.applicant.epcrJsonData.haddr ?? '',
        state.applicant.epcrJsonData.haddr2 ?? '',
        state.applicant.epcrJsonData.hcity ?? '',
        state.applicant.epcrJsonData.hstate ?? '',
        state.applicant.epcrJsonData.hzip ?? ''
      );
    }
    if (validatedAddress) {
      commit(SET_PCR_HOME_VALIDATED_ADDRESS, {
        homeValidatedAddress: validatedAddress,
        status: 'success',
      });
    }
  } catch (error) {
    commit(SET_PCR_HOME_VALIDATED_ADDRESS, {
      status: statuses.failure,
      error,
    });
  }
};
